export default {
  'sideNav.altText': 'Navigate to Dashboard'
};
